export const authStyles = {
  page: {
    minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center',
    justifyContent: 'center', backgroundColor: '#0b0f14', padding: '16px', boxSizing: 'border-box',
  },
  card: {
    width: '100%', maxWidth: '380px', backgroundColor: '#111820', borderRadius: '14px',
    padding: '24px', boxSizing: 'border-box', color: '#e8edf2',
  },
  title: { fontSize: '24px', fontWeight: 700, color: '#e8edf2', margin: '0 0 4px' },
  sub: { fontSize: '14px', color: '#93a1b1', margin: '0 0 20px' },
  label: { display: 'block', fontSize: '13px', color: '#93a1b1', marginBottom: '14px' },
  input: {
    display: 'block', width: '100%', boxSizing: 'border-box', marginTop: '6px',
    backgroundColor: '#161f2a', border: '1px solid #1e2936', borderRadius: '6px',
    color: '#e8edf2', padding: '12px', fontSize: '16px', minHeight: '44px',
  },
  error: { color: '#ff4d4f', fontSize: '14px', marginBottom: '12px' },
  button: {
    width: '100%', minHeight: '44px', backgroundColor: '#ff5a1f', color: '#0b0f14',
    border: 'none', borderRadius: '6px', fontSize: '15px', fontWeight: 700, cursor: 'pointer',
  },
  foot: { fontSize: '13px', color: '#93a1b1', margin: '16px 0 0', textAlign: 'center' },
  link: { color: '#ff5a1f' },
};
